(function () {
  function fontSize() {
    var size;
    var winW = window.innerWidth;

    size = Math.round(winW / 19.2 * 0.75);
    if (winW >= 1920) {
      size = 75;
    }
    document.getElementsByTagName("html")[0].style.fontSize = size + "px";
  }
  fontSize();

  window.addEventListener('resize', fontSize);
  window.addEventListener('pageshow', function(e){
    if (e.persisted) fontSize();
  });
})();